import React from 'react';

function SubmitSuccess(props) {
  return (
    <div>Thank you for reaching out to us. Someone will be in touch with you shortly!</div>
  );
}

export default SubmitSuccess;
